import { IModule, IModuleBuilder } from "app/IModule";
import { StateProvinceReducer } from "./stateProvince.reducer";

export default class GeoModule implements IModule {
  build(builder: IModuleBuilder) {
    builder.addReducer("stateProvinces", new StateProvinceReducer());
  }
}
